import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/app/homepage/components/ClientTestimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/app/homepage/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/Card3DTilt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/ColorfulWaves.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/CustomCursor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/EffectsInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/GlowingOrbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/HorizontalDragCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/KaleidoscopeBackground.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/Marquee.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/OverlayMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/ParticleNetwork.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/Preloader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/TestimonialAmbience.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/effects/WaveCanvas.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k/dev/dsmburo/src/components/ui/AppImage.tsx");
